import React from 'react';
import { Separator } from '../ui/separator';
import FluxFooter from '../FluxFooter';

const LegalPageLayout = ({ title, intro, lastUpdated, children }) => {
  return (
    <>
      <div className="flux-legal-page">
        <div className="flux-content-container">
          <header className="flux-legal-header">
            <p className="flux-legal-kicker">FluxSpaces</p>
            <h1 className="flux-legal-title">{title}</h1>
            {intro && <p className="flux-legal-intro">{intro}</p>}
            <p className="flux-legal-meta">
              Last updated: <span>{lastUpdated}</span>
            </p>
          </header>
          <Separator className="flux-legal-separator" />
          <div className="flux-legal-content">{children}</div>
        </div>
      </div>
      <FluxFooter />
    </>
  );
};

export default LegalPageLayout;
